import { lazy } from 'react'
import WidgetCategory from '../../WidgetCategory'
import { configOptions } from './config'

export const agentChatWidgetDescription = {
  name: 'AgentChat',
  component: lazy(() => import('./agent-chat-widget')),
  label: 'Agent Chat',
  category: WidgetCategory.experimental,
  variables: configOptions,
}
